import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import styles from './FAQSection.module.less';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQItemComponentProps {
  faq: FAQItem;
  isOpen: boolean;
  onClick: () => void;
  isFirst?: boolean;
}

const FAQItemComponent = ({ faq, isOpen, onClick, isFirst = false }: FAQItemComponentProps) => {
  return (
    <div className={styles.faqItem}>
      <button
        className={clsx(styles.faqQuestion, {
          [styles.faqQuestionFirst]: isFirst,
          [styles.faqQuestionOpen]: isOpen,
        })}
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span className={styles.questionText}>{faq.question}</span>
        <div className={clsx(styles.faqIcon, { [styles.faqIconOpen]: isOpen })}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.595731735229492"
            height="14.595731735229492"
            viewBox="0 0 14.595731735229492 14.595731735229492"
          >
            <path
              d="M13.8659 6.56802 L8.02771 6.56802 L8.02771 0.729844 C8.02771 0.32695 7.70076 0 7.29787 0 C6.89497 0 6.56802 0.32695 6.56802 0.729844 L6.56802 6.56802 L0.729844 6.56802 C0.32695 6.56802 0 6.89497 0 7.29787 C0 7.70076 0.32695 8.02771 0.729844 8.02771 L6.56802 8.02771 L6.56802 13.8659 C6.56802 14.2696 6.89497 14.5957 7.29787 14.5957 C7.70076 14.5957 8.02771 14.2696 8.02771 13.8659 L8.02771 8.02771 L13.8659 8.02771 C14.2696 8.02771 14.5957 7.70076 14.5957 7.29787 C14.5957 6.89497 14.2696 6.56802 13.8659 6.56802 Z"
              fill="currentColor"
              fillRule="nonzero"
            />
          </svg>
        </div>
      </button>
      {/* 使用 CSS Grid 实现平滑高度动画 */}
      <div
        className={styles.faqAnswerWrapper}
        style={{
          gridTemplateRows: isOpen ? '1fr' : '0fr',
        }}
        aria-hidden={!isOpen}
      >
        <div className={styles.faqAnswerInner}>
          <p className={styles.faqAnswer}>{faq.answer}</p>
        </div>
      </div>
    </div>
  );
};

/**
 * FAQ 常见问题组件
 */
export const FAQSection: React.FC = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqs: FAQItem[] = [
    {
      question: t('pricing.faq.q1.question'),
      answer: t('pricing.faq.q1.answer'),
    },
    {
      question: t('pricing.faq.q2.question'),
      answer: t('pricing.faq.q2.answer'),
    },
    {
      question: t('pricing.faq.q3.question'),
      answer: t('pricing.faq.q3.answer'),
    },
    {
      question: t('pricing.faq.q4.question'),
      answer: t('pricing.faq.q4.answer'),
    },
    {
      question: t('pricing.faq.q5.question'),
      answer: t('pricing.faq.q5.answer'),
    },
  ];

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className={styles.faqSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>{t('pricing.faq.title')}</h2>

        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <FAQItemComponent
              key={index}
              faq={faq}
              isOpen={openIndex === index}
              onClick={() => handleToggle(index)}
              isFirst={index === 0}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
